<template>
  <div class="modal" :id="modalId">
    <v-dialog persistent :value="value" @input="$emit('input')" max-width="700px">
      <v-card>
        <v-card-title class="headline">{{viewMode ? 'View' : 'Edit'}} Client Account</v-card-title>
        <v-card-text>
          <v-expansion-panels v-model="panels" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>Contact Details</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text>
                   <!-- Upload Media Components -->
                  <!-- <upload-media :key="uploadMediaKey" @change="mediaChanged" :listMedia="media" :logoURI="client.logoURI" :isEdit="true" />
                  <v-divider></v-divider> -->
                  <v-select
                    prepend-icon="business"
                    label="Assign a Company to client"
                    v-model="client.companyID"
                    :items="company_options"
                    item-text="name"
                    item-value="id"
                    :readonly="viewMode"
                    v-if="needCompany"
                  ></v-select>

                  <v-select
                    prepend-icon="person_outline"
                    label="Sales Representative"
                    v-model="client.salePerson"
                    :items="salePerson_options"
                    :readonly="viewMode"
                    item-text="firstName"
                    item-value="id"
                  ></v-select>
                  <v-autocomplete
                    prepend-icon="groups"
                    v-model="client.group"
                    :items="xeroContacts"
                    :readonly="viewMode"
                    label="Billing Name as per Xero"
                    item-text="Name"
                    attach
                    dense
                    return-object
                    @change="changeClientGroup"
                  ></v-autocomplete>

                  <v-text-field
                    prepend-icon="business"
                    label="Client Name (enter only if billing name as per xero cannot be found above)"
                    placeholder=""
                    v-model="client.name"
                    :readonly="viewMode"
                    :error-messages="nameErrors"
                    required
                    @input="$v.client.name.$touch()"
                    @blur="$v.client.name.$touch()"
                  ></v-text-field>

                  <!-- <v-text-field
                    prepend-icon="person"
                    label="Primary Contact Person"
                    placeholder=""
                    v-model="client.contactName"
                    :readonly="viewMode"
                    required
                  ></v-text-field> -->

                  <v-text-field
                    prepend-icon="phone"
                    label="Primary Contact Number"
                    placeholder=""
                    v-model.trim="client.phoneNumber"
                    :readonly="viewMode"
                    required
                  ></v-text-field>

                  <!-- <v-text-field
                    prepend-icon="email"
                    label="Primary Email"
                    placeholder=""
                    v-model.trim="client.email"
                    :readonly="viewMode"
                    @keydown.space.prevent
                    :error-messages="emailErrors"
                    @input="$v.client.email.$touch()"
                    @blur="$v.client.email.$touch()"
                  ></v-text-field> -->

                  <v-text-field
                    prepend-icon="location_on"
                    label="Address (to be included in invoice)"
                    placeholder="Enter Contact Address"
                    v-model="client.address"
                    :readonly="viewMode"
                    :error-messages="addressErrors"
                    required
                    @input="$v.client.address.$touch()"
                    @blur="$v.client.address.$touch()"
                  ></v-text-field>

                  <!-- <v-text-field
                    prepend-icon="http"
                    label="Website"
                    placeholder="Enter website"
                    v-model="client.website"
                  ></v-text-field> -->
                </v-card-text>
                <!-- contacts panel -->
                <v-expansion-panels v-model="contactPanels" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <v-row>
                        <v-col cols="12">
                          Contacts
                        </v-col>
                        <!-- <v-col class="mt-0 pt-0" cols="12">
                          <span class="caption">(Use this only if additional point of contact is needed)</span>
                        </v-col> -->
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-list dense v-for="(contact, index) in client.contacts" :key="index">
                        <v-list-item dense class="justify-end">
                          <v-checkbox
                            v-model="contact.includeEmail"
                            :readonly="viewMode"
                            label="Include in Email"
                            color="secondary"
                            :true-value="true"
                            :false-value="false"
                            hide-details
                            dense
                          ></v-checkbox>
                        </v-list-item>
                        <v-list-item dense>
                          <v-text-field
                            class="ma-0 pa-0"
                            prepend-icon="person"
                            label="Contact Person"
                            placeholder=""
                            v-model="contact.contactName"
                            :readonly="viewMode"
                            required
                          ></v-text-field>
                        </v-list-item>
                        <v-list-item dense>
                          <v-text-field
                            class="ma-0 pa-0"
                            prepend-icon="email"
                            label="Contact Email"
                            placeholder=""
                            v-model.trim="contact.email"
                            @keydown.space.prevent
                            @paste="preventPasteSpaces" 
                            :readonly="viewMode"
                            @change="checkAccEmail(index)"
                          ></v-text-field>
                        </v-list-item>
                        <v-list-item style="margin-top:-15px" v-if="contact.invalid" dense>
                          <p class="text-danger">Email Already Exists.</p>
                        </v-list-item>
                        <v-list-item dense>
                          <v-combobox
                            class="ma-0 mb-3 pa-0"
                            prepend-icon="mdi-file-check"
                            v-model="contact.campaigns"
                            :readonly="viewMode"
                            :items="campaigns"
                            item-text="name"
                            item-value="id"
                            outlined
                            dense
                            small-chips
                            label="Campaigns"
                            multiple
                            hide-details
                          ></v-combobox>
                        </v-list-item>
                        <v-list-item dense class="justify-end">
                          <v-btn
                            text
                            color="error"
                            @click="removeContact(index)"
                            v-if="!viewMode"
                          >
                            <v-icon left>mdi-delete-forever</v-icon>  Delete
                          </v-btn>
                        </v-list-item>
                        <v-divider class="ma-0 pa-0"></v-divider>
                      </v-list>
                      <v-btn
                        color="info"
                        class="ma-2 white--text"
                        @click="addDefaultContact()"
                        v-if="!viewMode"
                      >
                        <v-icon left dark>mdi-plus</v-icon> Add Contact
                      </v-btn>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- end of contacts panel -->
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>Account Details</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text>
                  <!-- <v-text-field
                    type="number"
                    prepend-icon="attach_money"
                    label="Account Budget"
                    placeholder="Enter account budget"
                    v-model.number="client.account.budget"
                    disabled
                  ></v-text-field> -->

                  <!-- <v-text-field
                    type="number"
                    prepend-icon="scatter_plot"
                    label="Total Outreach"
                    placeholder="Enter total outreach"
                    v-model.number="client.account.totalOutreach"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    type="number"
                    prepend-icon="score"
                    label="Total Engagement"
                    placeholder="Enter total engagement"
                    v-model.number="client.account.totalEngagement"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    type="number"
                    prepend-icon="notes"
                    label="Min. original content"
                    placeholder="Enter minimum numbers of content"
                    v-model.number="client.account.minContent"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    type="number"
                    prepend-icon="sort"
                    label="Max. original content"
                    placeholder="Enter maximum numbers of content"
                    v-model.number="client.account.maxContent"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    type="number"
                    prepend-icon="list_alt"
                    label="No. of Campaigns"
                    placeholder="Enter numbers of campaigns"
                    v-model.number="client.account.maxCampaigns"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-menu
                    ref="startMenu"
                    v-model="startCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="client.account.startDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="client.account.startDate"
                        label="Estimated Start Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="client.account.startDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="secondary" @click="startCal = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="secondary"
                        @click="$refs.startMenu.save(client.account.startDate)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu>

                  <v-menu
                    ref="expireMenu"
                    v-model="expireCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="client.account.expireDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="client.account.expireDate"
                        label="Expiry Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="client.account.expireDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="secondary" @click="startCal = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="secondary"
                        @click="$refs.expireMenu.save(client.account.expireDate)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu>                   -->

                  <div>
                    <!-- <v-divider v-show="accountDeals.length > 0"></v-divider> -->
                    <v-row v-show="accountDeals.length > 0" style="margin-top:20px;margin-bottom:20px;">
                      <v-col cols="12">
                        <v-card text elevation="0">
                          <v-expansion-panels >
                            <v-expansion-panel v-for="(item, index) in accountDeals" :key="index">
                              <v-expansion-panel-header style="text-transform: capitalize;" disable-icon-rotate>
                                <span>
                                  <p class="pr-2 pb-2 mb-0">
                                    {{getProductName(item.name)}}
                                  </p>
                                  <v-chip 
                                  color="green"
                                  outlined
                                  x-small
                                  :readonly="viewMode"
                                  v-if="item.masterListCheck && !viewMode">
                                    Masterlist 
                                    <v-icon color="success" small>mdi-check</v-icon>
                                  </v-chip>
                                  <v-btn
                                  color="warning"
                                  x-small
                                  v-if="!item.masterListCheck && !viewMode && isLinkMasterListBtn"
                                  @click="linkMasterlist(item)"
                                  >
                                    Link Masterlist
                                  </v-btn>
                                </span>
                                <v-spacer></v-spacer>
                                <!-- <template v-slot:actions>
                                  {{item.create_at}}
                                </template> -->
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-card-text >
                                  <v-row class="pa-0">
                                    <v-col cols="12" sm="6" >
                                      <v-flex xs12 md12>
                                        <label>Deals Budget</label>
                                        <p>{{item.budget || '-'}}</p>
                                      </v-flex>
                                    </v-col>
                                    <v-col cols="12" sm="6" >
                                      <v-flex xs12 md12>
                                        <label>IO</label>
                                        <p class="mb-2">{{item.IO || '-'}}</p>
                                      </v-flex>
                                    </v-col>
                                  </v-row>
                                  <v-row class="pa-0 mt-0">
                                    <v-col cols="12" sm="6" v-if="item.activationDate">
                                      <v-flex xs12 md12>
                                        <label>Activation Date</label>
                                        <p>{{item.activationDate}}</p>
                                      </v-flex>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-if="item.linkedIOs && item.linkedIOs.length">
                                      <v-flex xs12 md12>
                                        <label>Linked IO</label>
                                        <p>{{showLinkedIO(item.linkedIOs)}}</p>
                                      </v-flex>
                                    </v-col>
                                  </v-row>
                                  <v-row class="pa-0 mt-0">
                                    <v-col cols="12" sm="6" >
                                      <v-flex xs12 md12>
                                        <label>Quote Acceptance Date</label>
                                        <p>{{formattedDate(item.quoteAcceptanceDate)}}</p>
                                      </v-flex>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-if="item.markupCOGS">
                                      <v-flex xs12 md12>
                                        <label>Markup COGS Amount</label>
                                        <p>{{item.cogsAmount || '-'}}</p>
                                      </v-flex>
                                    </v-col>
                                  </v-row>
                                  <v-row class="pa-0 mt-0">
                                    <v-col cols="12" sm="6" v-if="item.vertical">
                                      <v-flex xs12 md12>
                                        <label>Campaign Vertical</label>
                                        <p>{{displayCampaignVerticals(item.vertical)}}</p>
                                      </v-flex>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-if="item.country">
                                      <v-flex xs12 md12>
                                        <label>Country</label>
                                        <p>
                                          <v-chip
                                            small
                                            v-for="(item, index) in item.country"
                                            :key="index"
                                            class="ma-1"
                                          >
                                            {{item.name}}
                                          </v-chip>
                                        </p>
                                      </v-flex>
                                    </v-col>
                                  </v-row>
                                  <v-row class="pa-0 mt-0">
                                    <v-col cols="12" sm="6">
                                      <v-flex xs12 md6>
                                        <label>Client Type</label>
                                        <p>{{getClientTypeDisplayValue(item.clientType)}}</p>
                                      </v-flex>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                      <v-flex xs12 md12>
                                        <label>Line of Services</label>
                                        <p>{{item.servicesLine}}</p>
                                      </v-flex>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                      <v-flex xs12 md6>
                                        <label>Remarks</label>
                                        <p>{{item.remarks || '-'}}</p>
                                      </v-flex>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" sm="12" >
                                      <v-expansion-panels>
                                        <v-expansion-panel v-for="(product, pindex) in item.products" :key="pindex">
                                          <v-expansion-panel-header style="text-transform: capitalize;">{{getProductName(product.name)}}</v-expansion-panel-header>
                                          <v-expansion-panel-content>
                                            <v-card-text v-show="product.name.toLowerCase() === 'storytell'">
                                              <v-row>
                                                <!-- <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                </v-col> -->
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-clipboard-list-outline</v-icon> No. of Campaigns: <strong>{{product.noOfCampaigns}}</strong>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-scatter-plot</v-icon> Total Outreach: <strong>{{product.totalOutReach}}</strong>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-chart-areaspline </v-icon> Total Engagement: <strong>{{product.totalEngagement}}</strong>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{product.minContent}}</strong>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{product.maxContent}}</strong>
                                                </v-col>
                                              </v-row>
                                              <!-- <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(product.startDate)}}</strong>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(product.expireDate)}}</strong>
                                                </v-col>
                                              </v-row> -->
                                              <v-row>
                                                <v-col cols="12" sm="12">
                                                  <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(product.createdDate)}}</strong>
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                            <v-card-text v-show="product.name.toLowerCase() === 'amplify'">
                                              <v-row>
                                                <!-- <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                </v-col> -->
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-file-eye-outline </v-icon> Views: <strong>{{product.views}}</strong>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{product.minContent || 0}}</strong>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{product.maxContent || product.noOfContents}}</strong>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> Duration: <strong>{{product.duration}} {{(product.duration > 1 ? 'Months' : 'Month')}}</strong>
                                                </v-col>
                                              </v-row>
                                              <!-- <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(product.startDate)}}</strong>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(product.expireDate)}}</strong>
                                                </v-col>
                                              </v-row> -->
                                              <v-row>
                                                <v-col cols="12" sm="12">
                                                  <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(product.createdDate)}}</strong>
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                            <v-card-text v-show="product.name.toLowerCase() === 'uncut' || product.name.toLowerCase() === 'aok'">
                                              <v-row>
                                                <!-- <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                </v-col> -->
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-scatter-plot</v-icon> Total Outreach: <strong>{{product.totalOutReach || '-'}}</strong>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{product.minContent || 0}}</strong>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{product.maxContent || product.noOfContents}}</strong>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                  <v-icon>mdi-text</v-icon> KPI Onboarded: <strong>{{product.kpiOnboarded || 0}}</strong>
                                                </v-col>
                                              </v-row>
                                              <!-- <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(product.startDate)}}</strong>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(product.endDate)}}</strong>
                                                </v-col>
                                              </v-row> -->
                                              <v-row>
                                                <v-col cols="12" sm="12">
                                                  <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(product.createdDate)}}</strong>
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                            <v-card-text v-show="product.name.toLowerCase() === 'others'">
                                              <!-- <v-row>
                                                <v-col cols="12" sm="12" >
                                                  <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                </v-col>
                                              </v-row> -->
                                              <!-- <v-row>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(product.startDate)}}</strong>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6" lg="6">
                                                  <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(product.expireDate)}}</strong>
                                                </v-col>
                                              </v-row> -->
                                              <v-row>
                                                <v-col cols="12" sm="12" >
                                                  <v-icon>mdi-bookmark</v-icon> Remark: <strong>{{product.remark}}</strong>
                                                </v-col>
                                              </v-row>
                                              <v-row>
                                                <v-col cols="12" sm="12" >
                                                  <v-icon>mdi-file-outline</v-icon> Nature of Deal: <strong>{{displayNatureOfDeals(product.natureOfDeal)}}</strong>
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                            <v-card-text v-show="product.name.toLowerCase() === 'loading fees'">
                                              <!-- <v-row>
                                                <v-col cols="12" sm="12" >
                                                  <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{product.budget}}</strong>
                                                </v-col>
                                              </v-row> -->
                                              <v-row>
                                                <v-col cols="12" sm="12" >
                                                  <v-icon>mdi-bookmark</v-icon> Remark: <strong>{{product.remark}}</strong>
                                                </v-col>
                                              </v-row>
                                            </v-card-text>
                                            <v-card-actions>
                                              <v-spacer></v-spacer>
                                                <!-- <v-btn
                                                icon
                                                color="info"
                                              >
                                                <v-icon>mdi-pencil</v-icon>
                                              </v-btn> -->
                                              <v-btn
                                                text
                                                color="error"
                                                v-if="buttonShow('delete') && !viewMode"
                                                @click="deleteProductsFromAccountDetails(index, pindex)"
                                              >
                                                <v-icon left>mdi-delete-forever</v-icon>  Delete
                                              </v-btn>
                                              <v-btn
                                                text
                                                color="warning"
                                                @click="reqForDelete(index, pindex)"
                                                v-if="!buttonShow('delete') && !viewMode"
                                              >
                                                <v-icon left>mdi-delete-forever</v-icon> Request for Delete
                                              </v-btn>
                                            </v-card-actions>
                                          </v-expansion-panel-content>
                                        </v-expansion-panel>
                                      </v-expansion-panels>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                    <v-btn
                                    text
                                    color="info"
                                    v-if="!viewMode"
                                    @click="dealsEdit(index)"
                                  >
                                    <v-icon left>mdi-pencil</v-icon> Edit
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="error"
                                    @click="deleteDeals(index, true)"
                                    v-if="buttonShow('delete') && !viewMode">
                                    <v-icon left>mdi-delete-forever</v-icon>  Delete
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="warning"
                                    @click="reqForDelete(index, null)"
                                    v-if="!buttonShow('delete') && !viewMode"
                                  >
                                    <v-icon left>mdi-delete-forever</v-icon>  Request for Delete
                                  </v-btn>
                                </v-card-actions>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-btn
                      color="info"
                      class="ma-2 white--text"
                      @click="addDeals"
                      v-if="!viewMode"
                      >
                      <v-icon
                        left
                        dark
                      >
                      mdi-plus
                      </v-icon>
                      Add Deals
                    </v-btn>
                  </div>
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>Assigned Team</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text>
                  <AssignTeam
                    @updateSelectedDedicated="updateSelectedDedicated"
                    @updateSelectedSupporting="updateSelectedSupporting"
                    :assignUsers="assignUsers"
                    :dedicatedData="dedicatedData"
                    :supportingData="supportingData"
                    :viewMode="viewMode"
                  />
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>Billing Details</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text>
                  <v-checkbox
                    v-model="sameWithContactInfo"
                    label="Billing information is same as contact information"
                    :readonly="viewMode"
                  ></v-checkbox>

                  <v-select
                    prepend-icon="payment"
                    label="Payment Mode"
                    v-model="client.paymentMode"
                    :items="clientPaymentModes"
                    item-text="name"
                    item-value="value"
                    :readonly="viewMode"
                  ></v-select>

                  <v-text-field
                    prepend-icon="location_on"
                    label="Billing Address"
                    placeholder="Enter Billing Address"
                    v-model="client.billingAddress"
                    :disabled="sameWithContactInfo || viewMode"
                  ></v-text-field>

                  <v-text-field
                    prepend-icon="phone"
                    label="Billing Contact"
                    placeholder="Enter billing contact number"
                    v-model="client.billingPhoneNumber"
                    :disabled="sameWithContactInfo || viewMode"
                  ></v-text-field>

                  <v-text-field
                    prepend-icon="email"
                    label="Billing Email"
                    placeholder="Enter billing email"
                    v-model.trim="client.billingEmail"
                    :disabled="sameWithContactInfo || viewMode"
                    :error-messages="emailErrors"
                    @input="$v.client.email.$touch()"
                    @blur="$v.client.email.$touch()"
                  ></v-text-field>
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- <v-expansion-panel>
              <v-expansion-panel-header disable-icon-rotate>
                Xero Integration
                <template v-slot:actions>
                  <v-icon color="error" v-if="!client.xeroContact">mdi-alert-circle</v-icon>
                  <v-icon color="success" v-if="client.xeroContact">mdi-check</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-combobox
                  v-model="client.xeroContact"
                  :items="xeroContacts"
                  label="Xero Contact"
                  item-text="Name"
                  outlined
                  dense
                ></v-combobox>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions v-if="!viewMode">
          <v-spacer></v-spacer>
          <v-btn text @click="closeEditModal">Close</v-btn>
          <v-btn color="secondary" @click="editClient" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn text @click="directCloseModal">Close</v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="loading" hide-overlay persistent width="250">
        <v-card color="primary" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-dialog>

    <!-- Account Details Add Deals Dialog -->
    <v-dialog
      v-model="addDealsDialog"
      persistent
      max-width="600px">
      <v-card style="min-width: 350px;">
        <v-card-title>
          <span class="headline">Add New Deals</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="dealForm">
            <v-container>
              <v-autocomplete
                class="mt-5"
                :items="displayMasterLists"
                item-text="quoteNo"
                item-value="quoteNo"
                label="IO Number"
                prepend-icon="mdi-file-outline"
                prefix="IO-"
                v-model="client.deals.IO"
                @change="changeIONumber"
                dense
                hide-details
                :rules="[rules.required]"
              ></v-autocomplete>
              <v-divider></v-divider>
              <!-- <v-text-field
                type="text"
                prepend-icon="mdi-file-outline"
                label="Linked IO"
                :value="showLinkedIO(client.deals.linkedIOs)"
                disabled
              ></v-text-field> -->
              <div class="mb-5">
                <label>Linked IO</label><br>
                <div class="d-flex flex-row mb-2" v-for="(linkIO, index) in client.deals.linkedIOs" :key="index">
                  <v-text-field
                    prefix="IO-"
                    v-model="client.deals.linkedIOs[index]"
                    v-on="on"
                    dense
                    outlined
                    hide-details
                    @change="changeLinkedIO"
                  ></v-text-field>
                  <v-btn
                    style="min-width:30px;height:36px;margin-left:5px;"
                    color="red"
                    small
                    @click="deleteLinkIO(index)"
                  >
                    <v-icon x-small style="color:#fff">mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
                <v-btn
                  class="mt-2 ml-0"
                  color="secondary"
                  small
                  @click="addLinkIO()"
                >
                  <v-icon title="Add Invoice Sent" small>mdi-plus</v-icon> Add
                </v-btn>
              </div>
              <v-menu
                ref="pickDate"
                v-model="pickDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="pt-3"
                    v-model="client.deals.quoteAcceptanceDate"
                    label="Quote Acceptance Date *"
                    prepend-icon="event"
                    dense
                    readonly
                    disabled
                    v-on="on"
                    :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="client.deals.quoteAcceptanceDate" no-title scrollable @input="pickDate = false">
                </v-date-picker>
              </v-menu>
              <v-text-field
                type="number"
                prepend-icon="attach_money"
                label="Budget"
                placeholder="Enter budget"
                v-model.number="client.deals.previewBudget"
                disabled
              ></v-text-field>
              <v-text-field
                type="number"
                prepend-icon="attach_money"
                label="Total Budget"
                placeholder="Enter Total Budget"
                v-model.number="client.deals.budget"
                :rules="[rules.required]"
                disabled
              ></v-text-field>
              <v-divider></v-divider>

              <v-text-field
                type="text"
                prepend-icon="mdi-file-outline"
                label="Deal Name *"
                placeholder="Enter Deal Name"
                v-model="client.deals.name"
                :rules="[rules.required]"
              ></v-text-field>

              <!-- <v-text-field
                type="number"
                prepend-icon="mdi-file-outline"
                prefix="IO-"
                label="IO Number"
                placeholder="Enter IO Number"
                v-model="client.deals.IO"
                :rules="[rules.required]"
              ></v-text-field> -->

              <div class="d-flex flex-row" style="justify-content:center">
                <v-text-field
                  placeholder="Activation Date"
                  v-model="client.deals.activationDate"
                  prepend-icon="mdi-file-outline"
                  dense
                  hide-details
                  @input="checkDate('activationDate')"
                  @keyup.enter="checkDate('activationDate')"
                  :rules="[rules.required]"
                >
                </v-text-field>
                <div class="date-picker-inner">
                  <date-picker
                    className="input-field"
                    :options="{theme: 'icon'}"
                    :status="actDateCal"
                    @changeDate="setDateFromPicker('activationDate', ...arguments)"
                  />
                </div>
              </div>

              <v-combobox
                class="mt-5 pt-2"
                v-model="client.deals.vertical"
                :items="campaignVerticals"
                item-text="name"
                item-value="name"
                prepend-icon="mdi-file-outline"
                hide-selected
                dense
                label="Campaign Vertical"
                multiple
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.name }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      $delete
                    </v-icon>
                  </v-chip>
                </template>
              </v-combobox>

              <!-- <v-autocomplete
                class="mt-5"
                prepend-icon="mdi-file-outline"
                v-model="client.deals.country"
                :items="countries"
                item-text="text"
                item-value="value"
                hide-selected
                chips
                label="Country"
                multiple
                dense
              >
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.text }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      $delete
                    </v-icon>
                  </v-chip>
                </template>
              </v-autocomplete> -->
              <v-combobox
                class="mt-5"
                v-model="client.deals.country"
                prepend-icon="mdi-file-outline"
                :items="countries"
                item-text="name"
                item-value="code"
                hide-selected
                multiple
                chips
                label="Country"
                dense
                :rules="[rules.required]"
              >
                <!-- <template v-slot:no-data>
                  <v-list-item>
                    <span class="subheading pr-2">Press Enter to Create</span>
                    <v-chip
                      label
                      small
                    >
                      {{ newCountry }}
                    </v-chip>
                  </v-list-item>
                </template> -->
                <template v-slot:selection="{ attrs, item, parent, selected }">
                  <v-chip
                    v-if="item === Object(item)"
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item.name }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      $delete
                    </v-icon>
                  </v-chip>
                  <!-- <v-chip
                    v-else
                    v-bind="attrs"
                    :input-value="selected"
                    label
                    small
                  >
                    <span class="pr-2">
                      {{ item }}
                    </span>
                    <v-icon
                      small
                      @click="parent.selectItem(item)"
                    >
                      $delete
                    </v-icon>
                  </v-chip> -->
                </template>
              </v-combobox>
              
              <v-select
                :items="clientTypes"
                item-text="title"
                item-value="value"
                class="mt-5 pt-2"
                label="Client Type"
                prepend-icon="mdi-file-outline"
                v-model="client.deals.clientType"
                dense
                hide-details
              ></v-select>

              <v-select
                v-model="client.deals.servicesLine"
                :items="lineOfServices"
                class="mt-5 pt-2"
                label="Line of Services"
                prepend-icon="mdi-file-outline"
                dense
                hide-details
                :rules="[rules.required]"
              ></v-select>

              <v-textarea
                filled
                class="mt-5 pt-2"
                label="Remarks"
                prepend-icon="mdi-bookmark-check-outline"
                v-model="client.deals.remarks"
              />

              <v-checkbox
                class="mt-0"
                v-model="client.deals.markupCOGS"
                hide-details
                label="this is a mark-up deal (special approval has been obtained prior)"
                small
                @change="changeMarkupCOGS"
              >
              </v-checkbox>
              <v-text-field
                type="number"
                label="COGS Amount"
                placeholder="Enter COGS Amount"
                v-model="client.deals.cogsAmount"
                :rules="[rules.required]"
                v-if="client.deals.markupCOGS"
              ></v-text-field>
            </v-container>
          </v-form>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                class="ma-2 white--text"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  left
                  dark
                >
                mdi-plus
                </v-icon>
                Add Products
              </v-btn>
            </template>
            <v-list>
              <v-list-item link @click="addProducts('Storytell')">
                <v-list-item-title>Storytell</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="addProducts('Amplify')">
                  <v-list-item-title>Amplify</v-list-item-title>
              </v-list-item>
              <!-- <v-list-item link @click="addProducts('Uncut')">
                <v-list-item-title>Uncut</v-list-item-title>
              </v-list-item> -->
              <v-list-item link @click="addProducts('aok')">
                <v-list-item-title>AOK/Uncut</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="addProducts('Loading Fees')">
                <v-list-item-title>Loading Fees</v-list-item-title>
              </v-list-item>
              <v-list-item link @click="addProducts('Others')">
                <v-list-item-title>Others</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- More Account Details Panel -->
          <v-divider v-show="accountProducts.length > 0"></v-divider>
          <v-row v-show="accountProducts.length > 0" style="margin-top:20px;margin-bottom:20px;">
            <v-col cols="12">
                <v-card text elevation="0">
                <v-expansion-panels >
                  <v-expansion-panel v-for="(item, index) in accountProducts" :key="index">
                    <v-expansion-panel-header style="text-transform: capitalize;">{{getProductName(item.name)}}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text v-show="item.name.toLowerCase() === 'storytell'">
                        <v-row>
                          <!-- <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col> -->
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-clipboard-list-outline</v-icon> No. of Campaigns: <strong>{{item.noOfCampaigns}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-scatter-plot</v-icon> Total Outreach: <strong>{{item.totalOutReach}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-chart-areaspline </v-icon> Total Engagement: <strong>{{item.totalEngagement}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{item.minContent}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{item.maxContent}}</strong>
                          </v-col>
                        </v-row>
                        <!-- <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(item.startDate)}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(item.expireDate)}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(item.createdDate)}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-show="item.name.toLowerCase() === 'amplify'">
                        <v-row>
                          <!-- <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col> -->
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-file-eye-outline </v-icon> Views: <strong>{{item.views}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{item.minContent || 0}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{item.maxContent || item.noOfContents}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Duration: <strong>{{item.duration}} Months</strong>
                          </v-col>
                        </v-row>
                        <!-- <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(item.startDate)}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(item.expireDate)}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(item.createdDate)}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-show="item.name.toLowerCase() === 'uncut'  || item.name.toLowerCase() === 'aok'">
                        <v-row>
                          <!-- <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col> -->
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-scatter-plot</v-icon> Total Outreach: <strong>{{item.totalOutReach || '-'}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-text</v-icon> Min. Original Contents: <strong>{{item.minContent || 0}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-sort-variant</v-icon> Max. Original Contents: <strong>{{item.maxContent || item.noOfContents}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="12" lg="12">
                            <v-icon>mdi-text</v-icon> KPI Onboarded: <strong>{{item.kpiOnboarded || 0}}</strong>
                          </v-col>
                        </v-row>
                        <!-- <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(item.startDate)}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(item.endDate)}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-icon>mdi-calendar</v-icon> Created Date: <strong>{{formattedDate(item.createdDate)}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-show="item.name.toLowerCase() === 'others'">
                        <!-- <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col>
                        </v-row> -->
                        <!-- <v-row>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> Start Month: <strong>{{formattedMonth(item.startDate)}}</strong>
                          </v-col>
                          <v-col cols="12" sm="12" md="6" lg="6">
                            <v-icon>mdi-calendar</v-icon> End Month: <strong>{{formattedMonth(item.expireDate)}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-bookmark-check-outline</v-icon> Remark: <strong>{{item.remark}}</strong>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-file-outline</v-icon> Nature of deal: <strong>{{displayNatureOfDeals(item.natureOfDeal)}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text v-show="item.name.toLowerCase() === 'loading fees'">
                        <!-- <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-currency-usd</v-icon> Account Budget: <strong>{{item.budget}}</strong>
                          </v-col>
                        </v-row> -->
                        <v-row>
                          <v-col cols="12" sm="12" >
                            <v-icon>mdi-bookmark-check-outline</v-icon> Remark: <strong>{{item.remark}}</strong>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          icon
                          color="info"
                          @click="productEdit(item, index)"
                        >
                          <v-icon>mdi-pencil</v-icon> Edit
                        </v-btn>
                        <v-btn
                          id="deleteDealsProduct"
                          text
                          color="error"
                          @click="deleteProducts(index)"
                        >
                          <v-icon left>mdi-delete-forever</v-icon>  Delete
                        </v-btn>
                      </v-card-actions>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="closeDealsModal"
            >
              Close
            </v-btn>
            <v-btn
              class="info"
              @click="addEditDeals"
            >
              {{(this.dealAction === 'add' ? 'Add' : 'Save')}}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Account Details Add or Edit Dialog -->
    <v-dialog
      v-model="addEditDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline" style="text-transform:capitalize;">{{showProductName}}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-container>
                  <!-- <v-text-field
                    type="number"
                    prepend-icon="attach_money"
                    label="Account Budget"
                    placeholder="Enter account budget"
                    v-model.number="client.moreAccount.budget"
                    :rules="[rules.required]"
                    @focus="$event.target.select()"
                  ></v-text-field> -->

                  <v-text-field
                    v-show="productName.toLowerCase() === 'amplify' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="mdi-file-eye-outline"
                    label="Views"
                    placeholder="Enter views"
                    v-model.number="client.moreAccount.views"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() === 'amplify' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="mdi-calendar"
                    label="Duration"
                    placeholder="Enter No. of months"
                    v-model.number="client.moreAccount.duration"
                  ></v-text-field>

                  <!-- <v-menu
                    ref="durationMenu"
                    v-model="durationCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="client.moreAccount.duration"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field  v-show="productName.toLowerCase() === 'amplify'"
                        v-model="client.moreAccount.duration"
                        label="Duration"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="client.moreAccount.duration" type="month" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="secondary" @click="durationCal = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="secondary"
                        @click="$refs.durationMenu.save(client.moreAccount.duration)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu> -->

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="scatter_plot"
                    label="Total Outreach"
                    placeholder="Enter total outreach"
                    v-model.number="client.moreAccount.totalOutReach"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'amplify' &&
                    productName.toLowerCase() !== 'uncut' &&
                    productName.toLowerCase() !== 'aok' &&
                    productName.toLowerCase() !== 'others' &&
                    productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="score"
                    label="Total Engagement"
                    placeholder="Enter total engagement"
                    v-model.number="client.moreAccount.totalEngagement"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="notes"
                    label="Min. original content"
                    placeholder="Enter minimum numbers of content"
                    v-model.number="client.moreAccount.minContent"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="sort"
                    label="Max. original content"
                    placeholder="Enter maximum numbers of content"
                    v-model.number="client.moreAccount.maxContent"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() === 'uncut' || productName.toLowerCase() === 'aok'"
                    type="number"
                    prepend-icon="sort"
                    label="KPI Onboarded"
                    placeholder="Enter KPI Onboarded"
                    v-model.number="client.moreAccount.kpiOnboarded"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <v-text-field
                    v-show="productName.toLowerCase() !== 'amplify' && productName.toLowerCase() !== 'uncut' && productName.toLowerCase() !== 'aok' && productName.toLowerCase() !== 'others' && productName.toLowerCase() !== 'loading fees'"
                    type="number"
                    prepend-icon="list_alt"
                    label="No. of Campaigns"
                    placeholder="Enter numbers of campaigns"
                    v-model.number="client.moreAccount.maxCampaigns"
                    @focus="$event.target.select()"
                  ></v-text-field>

                  <!-- <v-select
                    v-show="client.productName.toLowerCase() !== 'amplify' && client.productName.toLowerCase() !== 'uncut'"
                    prepend-icon="list_alt"
                    label="No. of Campaigns"
                    :items="numberOfCampaigns"
                    v-model.number="client.moreAccount.maxCampaigns"
                  ></v-select> -->

                  <!-- <v-menu
                    ref="moreStartMenu"
                    v-model="moreStartCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="client.moreAccount.startDate"
                        :label="productName.toLowerCase() === 'uncut' ? 'Start Month' : 'Start Month'"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="client.moreAccount.startDate" no-title scrollable @input="moreStartCal = false" type="month">
                    </v-date-picker>
                  </v-menu>

                  <v-menu
                    ref="moreExpireMenu"
                    v-model="moreExpireCal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="client.moreAccount.expireDate"
                        :label="productName.toLowerCase() === 'uncut' ? 'End Month' : 'End Month'"
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="client.moreAccount.expireDate" no-title scrollable  @input="moreExpireCal = false" type="month">
                    </v-date-picker>
                  </v-menu> -->

                  <v-textarea
                    v-show="productName.toLowerCase() === 'others' || productName.toLowerCase() === 'loading fees'"
                    filled
                    label="Remark"
                    placeholder="Remark"
                    prepend-icon="mdi-bookmark-check-outline"
                    v-model="client.moreAccount.remark"
                  ></v-textarea>

                  <v-combobox
                    v-show="productName.toLowerCase() === 'others'"
                    prepend-icon="mdi-file-outline"
                    label="Nature of deal"
                    :search-input.sync="newDealNature"
                    v-model="client.moreAccount.natureOfDeal"
                    :items="dealNatureLists"
                    item-text="name"
                    item-value="id"
                    chips
                    multiple
                    hide-selected
                    clearable
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <span class="subheading pr-2">Press Enter to Create</span>
                        <v-chip
                          label
                          small
                        >
                          {{ newDealNature }}
                        </v-chip>
                      </v-list-item>
                    </template>
                  </v-combobox>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeAddEditProductsModal"
          >
            Close
          </v-btn>
          <v-btn
            color="info"
            @click="addEditProduct"
          >
            {{(this.productAction === 'add' ? 'Add' : 'Save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import config from '@/config';
import clientConfig from './clientConfig.js';
// import campaignConfig from '../Campaign/config';
import clientAPIs from './clientAPIs';
import companyAPIs from '../Company/companyAPIs';
import userAPIs from '../User/userAPIs';
import campaignAPIs from '../Campaign/campaignAPIs';
import xeroAPIS from '../Xero/XeroAPIs';
import { required, email } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import moment from 'moment';
import uploadMedia from '../../upload'
import utils from '../../../utils'
import AssignTeam from './AssignTeam';
import DatePicker from '@/components/scoped/custom/DatePicker';
import campaignHelper from '../Campaign/campaignHelper';
import countries from '../../../../static/sources/countries';

export default {
  name: 'EditClientModal',
  props: {
    modalId: String,
    clientData: Object,
    viewMode: Boolean,
    value: Boolean
  },
  components: {
    AssignTeam,
    uploadMedia,
    DatePicker
  },
  mixins: [validationMixin],
  data() {
    return {
      countries,
      xeroContacts: [],
      company_options: [],
      salePerson_options: [],
      numberOfCampaigns: [1, 2, 3, 4, 5],
      panels: [0],
      contactPanels: [0],
      sameWithContactInfo: false,
      startCal: false,
      expireCal: false,
      moreStartCal: false,
      moreExpireCal: false,
      durationCal: false,
      loading: false,
      pickDate: false,
      client: {
        xeroContact: null,
        name: '',
        // contactName: '',
        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        salePerson: '',
        // email: '',
        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          deals: []
        },
        moreAccount: {
          budget: 0,
          totalOutReach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          views: '',
          durations: '',
          noOfContents: '',
          remark: ''
        },
        deals: {
          previewBudget: 0,
          budget: 0,
          IO: '',
          linkedIOs: [],
          markupCOGS: false,
          cogsAmount: '',
          products: [],
          vertical: [],
          country: [],
          clientType: '',
          servicesLine: '',
          activationDate: ''
        },
        media: [],
        contacts: []
      },
      addEditDialog: false,
      addDealsDialog: false,
      productName: '',
      accountProducts: [],
      accountDeals: [],
      rules: {
        required: value => !!value || 'Required.'
      },
      productAction: '',
      editItemIndex: '',
      dealAction: '',
      editDealItemIndex: '',
      handledBy: [],
      CO: [],
      orgHandledBy: [],
      AM: [],
      assignUsers: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      dedicatedData: [],
      supportingData: [],
      dealNatureLists: [],
      newDealNature: '',
      dealCounter: 0,
      // countries: campaignConfig.targetAudienceDisplay.LOCATION,
      clientTypes: [
        {
          title: 'Direct',
          value: 'direct'
        },
        {
          title: 'Agency',
          value: 'agency'
        }
      ],
      natureOfDealOptions: [
        'Loading Fees/whitelisting',
        'Physical Attendance/Event'
      ],
      lineOfServices: [
        'Storytell',
        'Storytell + BCA',
        'Storytell + Uncut',
        'Uncut',
        'Loading Fees',
        'Academy'
      ],
      displayMasterLists: []
    };
  },
  watch: {
    clientData: async function(newClientData) {
      await this.$store.dispatch('campaign/getCountries')
      await this.getIONumbers(newClientData.group ? newClientData.group.ContactID : null)
      // console.log('🚀 ~ file: EditClientModal.vue ~ line 1009 ~ newClientData', newClientData)
      this.handledBy = []
      let ObjMoreAccount = {
        budget: 0,
        totalOutReach: 0,
        totalEngagement: 0,
        minContent: 0,
        maxContent: 0,
        maxCampaigns: 0,
        startDate: '',
        expireDate: '',
        views: '',
        durations: '',
        noOfContents: ''
      }
      newClientData.moreAccount = Object.assign({}, ObjMoreAccount)

      let ObjDeals = {
        budget: 0,
        IO: '',
        linkedIOs: [],
        markupCOGS: false,
        cogsAmount: '',
        activationDate: '',
        products: []
      }
      newClientData.deals = Object.assign({}, ObjDeals)
      // newClientData.deals = {}
      // newClientData.deals.budget = ''
      // newClientData.deals.IO = ''
      // newClientData.deals.markupCOGS = false
      // newClientData.deals.cogsAmount = ''
      // newClientData.deals.activationDate = ''
      // newClientData.deals.products = ''
      // console.log('🚀 ~ file: EditClientModal.vue ~ line 1062 ~ this.client', this.client)
      await this.getAssignUsers()
      this.dedicatedData = []
      this.supportingData = []
      if (newClientData.handledBy) {
        this.assignUsers.map(item => {
          newClientData.handledBy.map(userId => {
            if (item.id === userId) {
              // this.orgHandledBy.push(item)
              this.dedicatedData.push(item)
              this.selectedDedicatedPersons.push(item)
            }
          })
        })
      }
      if (newClientData.supportedBy) {
        this.assignUsers.map(item => {
          newClientData.supportedBy.map(userId => {
            if (item.id === userId) {
              // this.orgHandledBy.push(item)
              this.supportingData.push(item)
            }
          })
        })
      }

      if (!newClientData.account) {
        this.client.account = {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          deals: []
        };
        this.accountDeals = []
      } else {
        if (newClientData.account.deals) {
          newClientData.account.deals = newClientData.account.deals.map(deal => {
            if (deal.country) {
              if (this.countries.length) {
                deal.country = campaignHelper.formatCountry(this.countries, deal.country || [])
              }
            }
            if (deal.IO) {
              deal.masterListCheck = this.getMasterlistCheck(deal.IO)
            }
            return deal
          })
          this.accountDeals = newClientData.account.deals
          this.dealCounter = newClientData.account.deals.length
        } else {
          this.accountDeals = []
          this.dealCounter = 0
        }
      }
      this.client = Object.assign({}, newClientData);

      // check for multiple contacts, campaigns
      await this.getCampaignsByClientID()
      if (this.client.contacts === undefined) {
        this.client.contacts = []
        // this.addDefaultContact(this.client.contactName, this.client.email)
      } else {
        this.client.contacts = this.client.contacts.map(c => {
          if (c.campaigns !== undefined) {
            c.campaigns = this.campaigns.filter(campaign => c.campaigns.includes(campaign.id))
          }
          return c
        })
      }
    },
    sameWithContactInfo: function(newInfo) {
      if (newInfo) {
        this.sameWithContactInfo = newInfo;
        this.client.billingPhoneNumber = this.client.phoneNumber;
        this.client.billingEmail = this.client.email;
        this.client.billingAddress = this.client.address;
      }
    }
  },
  validations: {
    client: {
      email: { email },
      name: { required },
      address: { required }
    }
  },
  computed: {
    ...mapState({
      // countries: state => state.campaign.countries,
      campaignVerticals: state => state.campaign.campaignVerticals,
      dealNatures: state => state.client.dealNatures,
      masterLists: state => state.campaign.masterLists
    }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    isLinkMasterListBtn: function() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.FINANCE
    },
    needCompany: function() {
      // If a new client is created naturally (but not by system admin),
      // then do not display the company dropdown list
      if (this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH || this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW) {
        return false;
      } else if (this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW) {
        return true;
      }
      return false;
    },
    clientPaymentModes: function() {
      return clientConfig.clientPaymentModes;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.client.name.$dirty) return errors;
      !this.$v.client.name.required && errors.push('Name is required');
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.client.address.$dirty) return errors;
      !this.$v.client.address.required && errors.push('Address is required');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.client.email.$dirty) return errors;
      !this.$v.client.email.email && errors.push('Invalid email format');
      return errors;
    },
    showProductName() {
      if (this.productName === 'aok') {
        return 'AOK/Uncut'
      }
      return this.productName
    },
    invalidContactEmail() {
      let isInvalid = false
      this.client.contacts.map(c => {
        if (c.invalid) isInvalid = true
      })
      return isInvalid
    },
    isEmptyContact() {
      if (this.client.contacts.length) {
        // if at least one contact, but no email
        if (!this.client.contacts[0].email) {
          return true
        }
        return false
      }
      return true
    }
    // computedSupportingPersons() {
    //   // exclude selected dedicated persons in supporting lists
    //   let personIds = this.selectedDedicatedPersons.map(v => v.id)
    //   return this.assignUsers.filter(a => !personIds.includes(a.id))
    // }
  },
  methods: {
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    },
    buttonShow(type) {
      const roleAllow = config['userPermissions']['client'][type]
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false
    },
    editClient: async function() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      }
      if (this.invalidContactEmail) {
        this.$swal({
          type: 'error',
          title: `Contact email already exists.`
        });
        return;
      }
      if (this.isEmptyContact) {
        this.$swal({
          type: 'error',
          title: `Please add at least one contact.`
        });
        return;
      }
      let hasAM = false
      let hasCC = false
      let dedicatedIDs = this.selectedDedicatedPersons.map(s => s.id)
      for (let AM of this.AM) {
        if (dedicatedIDs.includes(AM.id)) {
          hasAM = true
        }
      }
      for (let CC of this.CO) {
        if (dedicatedIDs.includes(CC.id)) {
          hasCC = true
        }
      }
      if (!hasAM || !hasCC) {
        this.$swal({
          type: 'error',
          title: `Please select at least one AM and CC`
        });
        return;
      }
      let client = Object.assign({}, this.client);
      delete client.companyID;
      delete client.moreAccount
      delete client.deals

      // client.account.products = this.accountProducts
      client.handledBy = [] // clear arry to re-insert
      this.selectedDedicatedPersons.map(item => {
        if (!client.handledBy.includes(item.id)) {
          client.handledBy.push(item.id)
        }
      })
      client.supportedBy = [] // clear arry to re-insert
      this.selectedSupportingPersons.map(item => {
        if (!client.supportedBy.includes(item.id)) {
          client.supportedBy.push(item.id)
        }
      })
      if (client.contacts.length > 0) {
        this.client.contacts = this.client.contacts.map(c => {
          if (c.campaigns !== undefined) {
            c.campaigns = c.campaigns.map(c => c.id)
          }
          return c
        })
      }
      /**
       * Remove CompanyID in unselect CO users
       */
      // let removeCompanyIdArray = this.orgHandledBy.filter(item => !this.handledBy.includes(item))
      // if (removeCompanyIdArray.length > 0) {
      //   removeCompanyIdArray.map((item) => {
      //     let users = {
      //       id: item.id,
      //       companyID: null
      //     }
      //     userAPIs.editUser(users)
      //   })
      // }

      /**
       * Add CompanyID in new selected CO users
       */
      // let addCompanyIdArray = this.handledBy.filter(item => !this.orgHandledBy.includes(item))
      // if (addCompanyIdArray.length > 0) {
      //   addCompanyIdArray.map((item) => {
      //     let users = {
      //       id: item.id,
      //       companyID: this.client.companyID
      //     }
      //     userAPIs.editUser(users)
      //   })
      // }
      let clientFormData = this.buildFormData(client)
      this.loading = true;
      // Edit client
      await clientAPIs
        .editClient(clientFormData, client.id)
        .then(response => {
          this.loading = false;
          this.updateClientUserCampaigns()
          // Return the newly added data to parent component
          this.$emit('editClient', response);
          this.$swal({
            title: 'Successful',
            text: `Client account is updated.`,
            type: 'success'
          }).then(() => {
            this.clearData();
            this.$emit('input')
          });
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            title: 'Error',
            text: error,
            type: 'error'
          });
          console.log('error', error);
        });
    },
    buildFormData(clientData) {
      clientData = this.filterEmptyContacts(clientData)
      let formData = new FormData();
      let client = Object.assign({}, clientData);

      const medias = client.media ? client.media.map(m => m.file) : [];
      // Beautify client data before store
      delete client.media
      formData.append('client', JSON.stringify(client));
      // formData.append('images', media);
      if (medias) {
        for (const media of medias) {
          formData.append('images', media);
        }
      }
      return formData;
    },
    clearData: function() {
      this.$v.$reset();
      this.client = {
        name: '',
        address: '',
        website: '',
        phoneNumber: '',
        companyID: '',
        salePerson: '',
        email: '',
        billingAddress: '',
        billingPhoneNumber: '',
        billingEmail: '',
        paymentMode: '',
        account: {
          budget: 0,
          totalOutreach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          products: [],
          deals: []
        },
        moreAccount: {
          budget: 0,
          totalOutReach: 0,
          totalEngagement: 0,
          minContent: 0,
          maxContent: 0,
          maxCampaigns: 0,
          startDate: '',
          expireDate: '',
          views: '',
          durations: '',
          noOfContents: ''
        },
        deals: {
          budget: 0,
          IO: '',
          linkedIOs: [],
          markupCOGS: false,
          cogsAmount: '',
          products: [],
          vertical: [],
          country: [],
          clientType: '',
          activationDate: ''
        },
        contacts: []
      };
      this.productName = ''
    },
    async fetchXeroContact() {
      try {
        const resp = await xeroAPIS.getXeroContacts();
        const respData = resp.data;
        const data = respData.data;
        this.xeroContacts = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    formattedDate(date) {
      return moment(date).format('DD MMM, YYYY')
    },
    formattedMonth(date) {
      return moment(date).format('MMM, YYYY')
    },
    clearMoreAccountData() {
      this.client.moreAccount.budget = ''
      this.client.moreAccount.totalOutReach = ''
      this.client.moreAccount.totalEngagement = ''
      this.client.moreAccount.minContent = ''
      this.client.moreAccount.maxContent = ''
      this.client.moreAccount.maxCampaigns = ''
      this.client.moreAccount.startDate = ''
      this.client.moreAccount.expireDate = ''
      this.client.moreAccount.views = ''
      this.client.moreAccount.noOfContents = ''
      this.client.moreAccount.duration = ''
    },
    addDeals() {
      this.dealAction = 'add'
      this.addDealsDialog = true
      // this.getIONumbers()
    },
    dealsEdit(i) {
      // Reassign object to accountProducts for not mutate original object
      let productsObject = Object.assign([], this.client.account.deals[i].products)
      this.dealAction = 'edit'
      this.editDealItemIndex = i
      this.accountProducts = productsObject
      this.client.deals.name = this.client.account.deals[i].name
      this.client.deals.budget = this.client.account.deals[i].budget
      this.client.deals.IO = this.cutIO(this.client.account.deals[i].IO)
      this.client.deals.linkedIOs = this.client.account.deals[i].linkedIOs
      this.client.deals.quoteAcceptanceDate = this.client.account.deals[i].quoteAcceptanceDate
      this.client.deals.country = this.client.account.deals[i].country
      this.client.deals.clientType = this.client.account.deals[i].clientType
      this.client.deals.servicesLine = this.client.account.deals[i].servicesLine
      this.client.deals.vertical = this.client.account.deals[i].vertical
      this.client.deals.remarks = this.client.account.deals[i].remarks
      this.client.deals.markupCOGS = this.client.account.deals[i].markupCOGS
      this.client.deals.activationDate = this.client.account.deals[i].activationDate
      this.client.deals.cogsAmount = this.client.account.deals[i].cogsAmount
      this.addDealsDialog = true
      // this.getIONumbers()
    },
    addProducts(name) {
      this.productAction = 'add'
      this.productName = name
      this.addEditDialog = true
    },
    productEdit(item, index) {
      this.productAction = 'edit'
      this.editItemIndex = index
      this.productName = item.name
      this.client.moreAccount.budget = item.budget
      this.client.moreAccount.totalOutReach = item.totalOutReach
      this.client.moreAccount.totalEngagement = item.totalEngagement
      this.client.moreAccount.minContent = item.minContent
      this.client.moreAccount.maxContent = item.maxContent
      this.client.moreAccount.maxCampaigns = item.noOfCampaigns
      this.client.moreAccount.kpiOnboarded = item.kpiOnboarded
      this.client.moreAccount.noOfContents = item.noOfContents
      this.client.moreAccount.views = item.views
      this.client.moreAccount.duration = item.duration
      this.client.moreAccount.remark = item.remark
      this.client.moreAccount.natureOfDeal = item.natureOfDeal
      // this.client.moreAccount.startDate = moment(item.startDate).format('YYYY-MM-DD')
      // this.client.moreAccount.expireDate = (item.name.toLowerCase() === 'uncut' ? moment(item.endDate).format('YYYY-MM-DD') : moment(item.expireDate).format('YYYY-MM-DD'))

      this.addEditDialog = true
    },
    addEditProduct() {
      let products = {}
      if (this.isProductBudgetExceeded()) {
        return
      }
      if (this.productAction === 'add') {
        if (this.$refs.form.validate()) {
          this.checkNatureOfDeals()
          switch (this.productName.toLowerCase()) {
            case 'storytell':
              products = {
                name: this.productName.toLowerCase(),
                budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
                totalOutReach: (this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-'),
                totalEngagement: (this.client.moreAccount.totalEngagement ? this.client.moreAccount.totalEngagement : '-'),
                minContent: (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-'),
                maxContent: (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-'),
                noOfCampaigns: (this.client.moreAccount.maxCampaigns ? this.client.moreAccount.maxCampaigns : '-'),
                startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
                expireDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
                createdDate: Date.now()
              }
              break
            case 'amplify':
              products = {
                name: this.productName.toLowerCase(),
                budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
                views: (this.client.moreAccount.views ? this.client.moreAccount.views : '-'),
                minContent: (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-'),
                maxContent: (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-'),
                duration: (this.client.moreAccount.duration ? this.client.moreAccount.duration : '-'),
                startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
                expireDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
                createdDate: Date.now()
              }
              break
            case 'uncut':
              products = {
                name: this.productName.toLowerCase(),
                budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
                totalOutReach: (this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-'),
                minContent: (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-'),
                maxContent: (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-'),
                kpiOnboarded: (this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-'),
                startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
                endDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
                createdDate: Date.now()
              }
              break
            case 'aok':
              products = {
                name: this.productName.toLowerCase(),
                budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
                totalOutReach: (this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-'),
                minContent: (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-'),
                maxContent: (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-'),
                kpiOnboarded: (this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-'),
                startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
                endDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
                createdDate: Date.now()
              }
              break
            case 'others':
              products = {
                name: this.productName.toLowerCase(),
                budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
                startDate: (this.client.moreAccount.startDate ? new Date(this.client.moreAccount.startDate) : '-'),
                expireDate: (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-'),
                remark: (this.client.moreAccount.remark ? this.client.moreAccount.remark : '-'),
                natureOfDeal: (this.client.moreAccount.natureOfDeal ? this.client.moreAccount.natureOfDeal : '-')
              }
              break
            case 'loading fees':
              products = {
                name: this.productName.toLowerCase(),
                budget: (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-'),
                remark: (this.client.moreAccount.remark ? this.client.moreAccount.remark : '-')
              }
              break
            default:
              break;
          }
          this.accountProducts.push(products)
          // console.log('🚀 ~ file: EditClientModal.vue ~ line 1543 ~ addEditProduct ~  this.accountProducts', this.accountProducts)
          // Adding account buget, totalOutreach, totalEngagement, minContent, maxContent and maxCampaigns before save
          // if (products.budget && products.budget !== '-') {
          //   // this.client.account.budget += products.budget
          //   this.client.deals.budget += products.budget
          // }

          // if (products.totalOutReach && products.totalOutReach !== '-') {
          //   this.client.account.totalOutreach += products.totalOutReach
          // }

          // if (products.totalEngagement && products.totalEngagement !== '-') {
          //   this.client.account.totalEngagement += products.totalEngagement
          // }

          // if (products.minContent && products.minContent !== '-') {
          //   this.client.account.minContent += products.minContent
          // }

          // if (products.maxContent && products.maxContent !== '-') {
          //   this.client.account.maxContent += products.maxContent
          // }

          // if (products.noOfCampaigns && products.noOfCampaigns !== '-') {
          //   this.client.account.maxCampaigns += products.noOfCampaigns
          // }
          //
          this.addEditDialog = false
          this.$refs.form.reset()
          this.clearMoreAccountData()
        }
      } else {
        this.checkNatureOfDeals()
        this.accountProducts[this.editItemIndex].budget = (this.client.moreAccount.budget ? this.client.moreAccount.budget : '-')
        this.accountProducts[this.editItemIndex].totalOutReach = (this.client.moreAccount.totalOutReach ? this.client.moreAccount.totalOutReach : '-')
        this.accountProducts[this.editItemIndex].views = (this.client.moreAccount.views ? this.client.moreAccount.views : '-')
        this.accountProducts[this.editItemIndex].noOfContents = (this.client.moreAccount.noOfContents ? this.client.moreAccount.noOfContents : '-')
        this.accountProducts[this.editItemIndex].duration = (this.client.moreAccount.duration ? this.client.moreAccount.duration : '-')
        this.accountProducts[this.editItemIndex].totalEngagement = (this.client.moreAccount.totalEngagement ? this.client.moreAccount.totalEngagement : '-')
        this.accountProducts[this.editItemIndex].minContent = (this.client.moreAccount.minContent ? this.client.moreAccount.minContent : '-')
        this.accountProducts[this.editItemIndex].maxContent = (this.client.moreAccount.maxContent ? this.client.moreAccount.maxContent : '-')
        this.accountProducts[this.editItemIndex].noOfCampaigns = (this.client.moreAccount.maxCampaigns ? this.client.moreAccount.maxCampaigns : '-')
        this.accountProducts[this.editItemIndex].kpiOnboarded = (this.client.moreAccount.kpiOnboarded ? this.client.moreAccount.kpiOnboarded : '-')
        this.accountProducts[this.editItemIndex].remark = (this.client.moreAccount.remark ? this.client.moreAccount.remark : '-')
        this.accountProducts[this.editItemIndex].natureOfDeal = (this.client.moreAccount.natureOfDeal ? this.client.moreAccount.natureOfDeal : '-')
        this.accountProducts[this.editItemIndex].startDate = (this.client.moreAccount.startDate ? this.client.moreAccount.startDate : '-')
        if (this.accountProducts[this.editItemIndex].name.toLowerCase() === 'uncut') {
          this.accountProducts[this.editItemIndex].endDate = (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-')
        } else {
          this.accountProducts[this.editItemIndex].expireDate = (this.client.moreAccount.expireDate ? new Date(this.client.moreAccount.expireDate) : '-')
        }
        this.accountProducts[this.editItemIndex].createdDate = Date.now()
        /**
         * #NOTE
         * ReCalculating total budget, Outreach, Engagement, Min Contents, Max Contents, No. of Campaigns
         * and update to main account
         */
        let totalBudget = 0
        let totalOutreach = 0
        let totalEngagement = 0
        let totalMinContents = 0
        let totalMaxContents = 0
        let noOfCampaigns = 0
        this.accountProducts.map((item) => {
          totalBudget += item.budget
          totalOutreach += item.totalOutReach
          totalEngagement += item.totalEngagement
          totalMinContents += item.minContent
          totalMaxContents += item.maxContent
          noOfCampaigns += item.noOfCampaigns
        })
        this.client.account.budget = totalBudget
        this.client.account.totalOutreach = totalOutreach
        this.client.account.totalEngagement = totalEngagement
        this.client.account.minContent = totalMinContents
        this.client.account.maxContent = totalMaxContents
        this.client.account.maxCampaigns = noOfCampaigns

        /** */

        this.addEditDialog = false
        this.$refs.form.reset()
        this.clearMoreAccountData()
      }
    },
    addEditDeals() {
      if (this.$refs.dealForm.validate()) {
        if (!this.client.deals.country.length) {
          this.$swal({
            type: 'warning',
            title: `Please select country.`
          });
          return
        }
        this.changeLinkedIO()
        if (this.dealAction === 'add') {
          this.client.deals.IO = utils.func.escapeSpecialChars(this.client.deals.IO)
          this.checkCountrySave()
          this.dealCounter += 1
          let deals = {
            name: this.client.deals.name,
            budget: this.client.deals.budget,
            IO: this.prefixIO(this.client.deals.IO),
            linkedIOs: this.client.deals.linkedIOs || [],
            quoteAcceptanceDate: this.client.deals.quoteAcceptanceDate,
            remarks: this.client.deals.remarks,
            markupCOGS: this.client.deals.markupCOGS,
            activationDate: this.client.deals.activationDate,
            cogsAmount: this.client.deals.cogsAmount,
            products: this.accountProducts,
            country: this.client.deals.country,
            clientType: this.client.deals.clientType,
            servicesLine: this.client.deals.servicesLine,
            vertical: this.client.deals.vertical,
            masterListID: this.client.deals.masterListID,
            masterListCheck: this.getMasterlistCheck(this.client.deals.IO),
            create_at: this.formattedDate(Date.now())
          }
          // this.client.account.deals.push(deals)
          this.accountDeals.push(deals)

          // Adding account buget, totalOutreach, totalEngagement, minContent, maxContent and maxCampaigns before save
          // if (deals.budget && deals.budget !== '-') {
          //   this.client.account.budget += deals.budget
          // }

          deals.products.map((item) => {
            if (item.totalOutReach && item.totalOutReach !== '-') {
              this.client.account.totalOutreach += item.totalOutReach
            }

            if (item.totalEngagement && item.totalEngagement !== '-') {
              this.client.account.totalEngagement += item.totalEngagement
            }

            if (item.minContent && item.minContent !== '-') {
              this.client.account.minContent += item.minContent
            }

            if (item.maxContent && item.maxContent !== '-') {
              this.client.account.maxContent += item.maxContent
            }

            if (item.noOfCampaigns && item.noOfCampaigns !== '-') {
              this.client.account.maxCampaigns += item.noOfCampaigns
            }
          })
          this.client.account.deals = this.accountDeals
        } else {
          this.client.deals.IO = utils.func.escapeSpecialChars(this.client.deals.IO)
          this.accountDeals[this.editDealItemIndex].name = (this.client.deals.name ? this.client.deals.name : '-')
          this.accountDeals[this.editDealItemIndex].IO = (this.client.deals.IO ? this.prefixIO(this.client.deals.IO) : '-')
          this.accountDeals[this.editDealItemIndex].masterListCheck = this.getMasterlistCheck((this.client.deals.IO ? this.prefixIO(this.client.deals.IO) : '-'))
          this.accountDeals[this.editDealItemIndex].linkedIOs = (this.client.deals.linkedIOs ? this.client.deals.linkedIOs : [])
          this.accountDeals[this.editDealItemIndex].quoteAcceptanceDate = (this.client.deals.quoteAcceptanceDate ? this.client.deals.quoteAcceptanceDate : '-')
          this.accountDeals[this.editDealItemIndex].markupCOGS = (this.client.deals.markupCOGS ? this.client.deals.markupCOGS : false)
          this.accountDeals[this.editDealItemIndex].activationDate = (this.client.deals.activationDate ? this.client.deals.activationDate : '')
          this.accountDeals[this.editDealItemIndex].cogsAmount = (this.client.deals.cogsAmount ? this.client.deals.cogsAmount : '')
          this.accountDeals[this.editDealItemIndex].remarks = (this.client.deals.remarks ? this.client.deals.remarks : '-')
          this.accountDeals[this.editDealItemIndex].country = (this.client.deals.country ? this.client.deals.country : '-')
          this.accountDeals[this.editDealItemIndex].clientType = (this.client.deals.clientType ? this.client.deals.clientType : '-')
          this.accountDeals[this.editDealItemIndex].servicesLine = (this.client.deals.servicesLine ? this.client.deals.servicesLine : '-')
          this.accountDeals[this.editDealItemIndex].vertical = (this.client.deals.vertical ? this.client.deals.vertical : '-')
          this.accountDeals[this.editDealItemIndex].masterListID = (this.client.deals.masterListID ? this.client.deals.masterListID : '')
          this.accountDeals[this.editDealItemIndex].create_at = this.formattedDate(Date.now())
          this.accountDeals[this.editDealItemIndex].products = this.accountProducts
          /**
           * #NOTE
           * ReCalculating total budget, Outreach, Engagement, Min Contents, Max Contents, No. of Campaigns
           * and update to main account
           */
          // let totalBudget = 0
          let totalOutreach = 0
          let totalEngagement = 0
          let totalMinContents = 0
          let totalMaxContents = 0
          let noOfCampaigns = 0
          this.accountDeals[this.editDealItemIndex].products.map((item) => {
            // totalBudget = item.budget
            if (item.totalOutReach) {
              totalOutreach += item.totalOutReach
            }

            if (item.totalEngagement) {
              totalEngagement += item.totalEngagement
            }

            if (item.minContent) {
              totalMinContents += item.minContent
            }

            if (item.maxContent) {
              totalMaxContents += item.maxContent
            }

            if (item.noOfCampaigns) {
              noOfCampaigns += item.noOfCampaigns
            }
          })
          // this.client.account.budget = totalBudget
          this.client.account.totalOutreach = totalOutreach
          this.client.account.totalEngagement = totalEngagement
          this.client.account.minContent = totalMinContents
          this.client.account.maxContent = totalMaxContents
          this.client.account.maxCampaigns = noOfCampaigns
          this.client.account.deals[this.editDealItemIndex].name = this.client.deals.name
          this.client.account.deals[this.editDealItemIndex].budget = this.client.deals.budget
          this.client.account.deals[this.editDealItemIndex].IO = this.prefixIO(this.client.deals.IO)
          this.client.account.deals[this.editDealItemIndex].masterListCheck = this.getMasterlistCheck((this.client.deals.IO ? this.prefixIO(this.client.deals.IO) : '-'))
          this.client.account.deals[this.editDealItemIndex].linkedIOs = this.client.deals.linkedIOs
          this.client.account.deals[this.editDealItemIndex].quoteAcceptanceDate = this.client.deals.quoteAcceptanceDate
          this.client.account.deals[this.editDealItemIndex].remarks = this.client.deals.remarks
          this.client.account.deals[this.editDealItemIndex].activationDate = this.client.deals.activationDate
          this.client.account.deals[this.editDealItemIndex].markupCOGS = this.client.deals.markupCOGS
          this.client.account.deals[this.editDealItemIndex].cogsAmount = this.client.deals.cogsAmount
          this.client.account.deals[this.editDealItemIndex].country = this.client.deals.country
          this.client.account.deals[this.editDealItemIndex].clientType = this.client.deals.clientType
          this.client.account.deals[this.editDealItemIndex].servicesLine = this.client.deals.servicesLine
          this.client.account.deals[this.editDealItemIndex].vertical = this.client.deals.vertical
          this.client.account.deals[this.editDealItemIndex].masterListID = this.client.deals.masterListID
          // this.accountDeals[this.editDealItemIndex].budget = totalBudget

          /** */
        }
        this.addDealsDialog = false
        this.clearDeals()
      }
    },
    clearDeals() {
      // this.$refs.dealForm.reset();
      this.client.deals.name = ''
      this.client.deals.budget = 0
      this.client.deals.IO = ''
      this.client.deals.linkedIOs = []
      this.client.deals.masterListID = ''
      this.client.deals.activationDate = ''
      this.client.deals.markupCOGS = false
      this.client.deals.cogsAmount = 0
      this.client.deals.products = []
      this.client.deals.country = []
      this.client.deals.clientType = ''
      this.client.deals.servicesLine = ''
      this.client.deals.vertical = []
      this.accountProducts = []
    },
    closeAddEditProductsModal () {
      this.$refs.form.reset()
      this.addEditDialog = false
    },
    directCloseModal() {
      this.$emit('input')
    },
    async closeEditModal() {
      const confirm = await this.closeConfirmationModal()
      if (!confirm) {
        return
      }
      this.$emit('input')
      this.accountProducts = []
      this.handledBy = []
    },
    async deleteProducts(i) {
      const deleteIt = await this.deletConfirmationModal('Are you sure to delete this product?')

      if (!deleteIt) {
        return
      }

      // if (this.client.account.budget) {
      //   this.client.deals.budget -= parseInt(this.accountProducts[i].budget, 10)
      // }

      this.accountProducts.splice(i, 1)
    },
    async deletConfirmationModal(msg) {
      const result = await this.$swal({
        title: 'Please confirm',
        text: msg,
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Delete.'
      });
      return result.value;
    },
    async closeConfirmationModal() {
      const result = await this.$swal({
        title: 'Please confirm',
        text: 'Are you sure to close?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes'
      });
      return result.value;
    },
    mediaChanged(media) {
      this.client.media = media;
      // this.$emit('media-changed', media);
    },
    async deleteDeals(i, modal = false) {
      // console.log('deleteDeals', this.accountDeals)
      if (modal) {
        const deleteIt = await this.deletConfirmationModal('Are you sure to delete this deal?')

        if (!deleteIt) {
          return
        }
      }

      if (this.client.account.budget) {
        this.client.account.budget -= this.accountDeals[i].budget
      }

      this.accountDeals[i].products.map((item) => {
        if (this.client.account.totalOutreach) {
          this.client.account.totalOutreach -= item.totalOutReach
        }

        if (this.client.account.totalEngagement) {
          this.client.account.totalEngagement -= item.totalEngagement
        }

        if (this.client.account.minContent) {
          this.client.account.minContent -= item.minContent
        }

        if (this.client.account.maxContent) {
          this.client.account.maxContent -= item.maxContent
        }

        if (this.client.account.maxCampaigns) {
          this.client.account.maxCampaigns -= item.noOfCampaigns
        }
      })

      this.accountDeals.splice(i, 1)
      if (this.accountDeals.length === 0) {
        this.dealCounter = 0
      }
    },
    async deleteProductsFromAccountDetails(i, j) {
      const deleteIt = await this.deletConfirmationModal('Are you sure to delete this product?')

      if (!deleteIt) {
        return
      }

      // console.log('Client account deals', this.client.account.deals[i].products[j])
      if (this.client.account.budget && this.client.account.deals[i].budget) {
        this.client.account.budget -= parseInt(this.client.account.deals[i].products[j].budget, 10)
        this.client.account.deals[i].budget -= parseInt(this.client.account.deals[i].products[j].budget, 10)
      }

      if (this.client.account.deals[i].products[j].totalOutReach) {
        this.client.account.totalOutreach -= parseInt(this.client.account.deals[i].products[j].totalOutReach, 10)
      }

      if (this.client.account.deals[i].products[j].totalEngagement) {
        this.client.account.totalEngagement -= parseInt(this.client.account.deals[i].products[j].totalEngagement, 10)
      }

      if (this.client.account.deals[i].products[j].minContent) {
        this.client.account.minContent -= parseInt(this.client.account.deals[i].products[j].minContent, 10)
      }

      if (this.client.account.deals[i].products[j].maxContent) {
        this.client.account.maxContent -= parseInt(this.client.account.deals[i].products[j].maxContent, 10)
      }

      if (this.client.account.deals[i].products[j].noOfCampaigns) {
        this.client.account.maxCampaigns -= parseInt(this.client.account.deals[i].products[j].noOfCampaigns, 10)
      }

      this.client.account.deals[i].products.splice(j, 1)
      if (this.client.account.deals[i].products.length === 0) {
        this.deleteDeals(i)
      }
    },
    closeDealsModal() {
      this.$refs.dealForm.reset()
      this.accountProducts = []
      this.addDealsDialog = false
    },
    cutIO(IO) {
      var re = new RegExp('IO-', 'g')
      return IO.replace(re, '')
    },
    prefixIO(value) {
      return `IO-${value}`
    },
    addDefaultContact(name = '', email = '') {
      this.client.contacts.push({
        contactName: name,
        email: email,
        includeEmail: true,
        invalid: false
      })
      this.client = utils.func.refreshJSON(this.client)
    },
    removeContact(index) {
      if (this.client.deletedContacts === undefined) {
        this.client.deletedContacts = []
      }
      this.client.deletedContacts.push(...this.client.contacts.splice(index, 1))
    },
    filterEmptyContacts(clientData) {
      if (clientData.contacts !== undefined) {
        clientData.contacts = clientData.contacts.filter(c => c.contactName !== '' && c.email !== '')
        clientData.contacts = clientData.contacts.map(c => {
          c.email = c.email.toLowerCase()
          return c
        })
      }
      return clientData
    },
    getProductName(itemName) {
      if (itemName === 'aok') {
        return 'AOK/Uncut'
      }
      return itemName
    },
    async getCampaignsByClientID() {
      // get all campaigns
      let response = await campaignAPIs.getCampaignsByClientID(this.client.id)
      if (response) {
        this.campaigns = response.campaigns.map(r => Object.assign({}, {id: r.id, name: r.name}))
      }
    },
    changeMarkupCOGS() {
      this.client = utils.func.refreshJSON(this.client)
    },
    changeClientGroup() {
      this.client.name = this.client.group ? this.client.group.Name : ''
      this.getIONumbers(this.client.group.ContactID)
    },
    displayCampaignVerticals(vertical) {
      let selectedCampaignVertical = []
      if (vertical) {
        this.campaignVerticals.map(item => {
          vertical.map(v => {
            if (item.id === v.id) {
              selectedCampaignVertical.push(item)
            }
          })
        })
      }
      return selectedCampaignVertical.map(s => s.name).join(', ')
    },
    getCountryDisplayValueFromSelect: function(value) {
      if (typeof value === 'string') return value
      var selectedOption = this.countries.filter(option => {
        return value.includes(option.value)
      });
      return selectedOption ? selectedOption.map(o => o.text).join(', ') : '-';
    },
    getClientTypeDisplayValue(value) {
      if (value) {
        let matchClient = this.clientTypes.find(c => c.value === value)
        if (matchClient) return matchClient.title
      }
      return '-'
    },
    displayNatureOfDeals(deals) {
      return Array.isArray(deals) ? deals.map(d => d.name || '').join(', ') : ''
    },
    updateSelectedDedicated(newValue) {
      this.selectedDedicatedPersons = Object.assign([], newValue)
    },
    updateSelectedSupporting(newValue) {
      this.selectedSupportingPersons = Object.assign([], newValue)
    },
    async getAssignUsers() {
      // Get all CO user by role
      let resp = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (resp) this.CO = resp.users;
      // Get all AM user by role
      resp = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      if (resp) this.AM = resp.users
      this.assignUsers = Object.assign([], [...this.CO, ...this.AM])
    },
    checkNatureOfDeals() {
      if (this.client.moreAccount) {
        if (this.client.moreAccount.natureOfDeal) {
          this.client.moreAccount.natureOfDeal = this.client.moreAccount.natureOfDeal.map(v => {
            if (typeof v === 'string') {
              v = {
                id: 0,
                name: v
              }
              this.dealNatureLists.push(v)
            }
            return v
          })
        }
      }
    },
    checkCountrySave() {
      if (this.client.deals.country) {
        this.client.deals.country = this.client.deals.country.map(v => {
          if (typeof v === 'string') {
            v = {
              id: 0,
              name: v,
              code: v
            }
            this.countries.push(v)
          }
          return v
        })
      }
    },
    async reqForDelete(dealIdx, productIdx = null) {
      const deleteIt = await this.$swal({
        title: 'Please confirm',
        text: 'Are you sure to send delete request?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send Request'
      });
      if (!deleteIt.value) {
        return
      }
      let reqData = {
        dealName: this.accountDeals[dealIdx].name,
        productName: ''
      }
      if (productIdx !== null) {
        reqData.productName = this.accountDeals[dealIdx].products[productIdx].name
      }
      let resp = await clientAPIs.sendDeleteReq(reqData, this.client.id)
      if (resp) {
        this.$swal({
          type: 'success',
          title: `Successfully requested for deletion.`
        });
      } else {
        this.$swal({
          type: 'error',
          title: `Error sending delete request.`
        });
      }
    },
    async getIONumbers(contactID) {
      if (contactID) {
        await this.$store.dispatch('campaign/getCampaignMasterListsIONumbers', {
          filters: {
            contactID
          }
        })
      } else {
        await this.$store.dispatch('campaign/getCampaignMasterListsIONumbers', {})
      }
      this.displayMasterLists = []
      this.displayMasterLists = this.masterLists.map(m => {
        m.quoteNo = m.quoteNo ? this.cutIO(m.quoteNo) : ''
        return m
      })
      if (contactID) {
        this.displayMasterLists = this.displayMasterLists.filter(master => {
          if (master.billingContact) {
            if (master.billingContact.ContactID === contactID) return true
          }
          return false
        })
      }
    },
    changeIONumber() {
      const matchMasterData = this.findMasterList(this.client.deals.IO)
      this.client.deals.masterListID = ''
      this.client.deals.quoteAcceptanceDate = ''
      this.client.deals.previewBudget = ''
      this.client.deals.budget = ''
      this.client.deals.linkedIOs = []
      if (matchMasterData) {
        const mainIO = this.normalizeIONumber(matchMasterData.quoteNo)
        const linkedIOs = Array.isArray(matchMasterData.linkedIOs) ? matchMasterData.linkedIOs : []
        this.client.deals.linkedIOs = [...new Set(linkedIOs
          .map(linkedIO => this.normalizeIONumber(linkedIO))
          .filter(linkedIO => linkedIO && linkedIO !== mainIO && this.findMasterList(linkedIO)))]
        this.client.deals.previewBudget = this.getIOBudget(matchMasterData)
        this.client.deals.masterListID = matchMasterData.id
        this.client.deals.quoteAcceptanceDate = utils.func.parseDate(matchMasterData.acceptanceDate)
        this.client.deals.budget = this.calculateTotalIOBudget(matchMasterData, this.client.deals.linkedIOs)
      }
    },
    changeLinkedIO() {
      const matchMasterData = this.findMasterList(this.client.deals.IO)
      if (matchMasterData) {
        const mainIO = this.normalizeIONumber(matchMasterData.quoteNo)
        this.client.deals.linkedIOs = [...new Set((this.client.deals.linkedIOs || [])
          .map(linkedIO => this.normalizeIONumber(linkedIO))
          .filter(linkedIO => linkedIO && linkedIO !== mainIO))]
        this.client.deals.previewBudget = this.getIOBudget(matchMasterData)
        this.client.deals.budget = this.calculateTotalIOBudget(matchMasterData, this.client.deals.linkedIOs)
      }
    },
    normalizeIONumber(value) {
      return String(value || '').trim().replace(/^IO-/i, '')
    },
    findMasterList(ioNumber) {
      const normalizedIO = this.normalizeIONumber(ioNumber)
      return this.masterLists.find(master => this.normalizeIONumber(master.quoteNo) === normalizedIO)
    },
    getIOBudget(masterList) {
      if (!masterList) return 0
      const budget = Number(String(masterList.quoteAmt || 0).replace(/,/g, ''))
      return Number.isFinite(budget) ? budget : 0
    },
    calculateTotalIOBudget(mainMasterList, linkedIOs) {
      return [...new Set(linkedIOs || [])].reduce((total, linkedIO) => {
        return total + this.getIOBudget(this.findMasterList(linkedIO))
      }, this.getIOBudget(mainMasterList))
    },
    getMasterlistCheck(IONumber) {
      let masterListExist = this.masterLists.find(m => this.cutIO(m.quoteNo) === this.cutIO(IONumber))
      if (masterListExist) return true
      return false
    },
    linkMasterlist(item) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure to link masterlist',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.loading = true
          let updateData = Object.assign({}, {
            clientID: this.client.id,
            salePerson: this.client.salePerson,
            billingContact: this.client.group,
            IO: item.IO,
            budget: item.budget,
            quoteAcceptanceDate: item.quoteAcceptanceDate,
            clientType: item.clientType
          })
          await this.$store.dispatch('campaign/linkMasterlist', updateData)
          await this.getIONumbers(this.client.group.ContactID)
          this.loading = false
          this.$swal({
            title: 'Successful',
            text: `Successfully Linked Masterlist.`,
            type: 'success'
          })
        }
      })
    },
    isProductBudgetExceeded() {
      if (Number(this.client.moreAccount.budget) > Number(this.client.deals.budget)) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Product budget cannot be greater than Deal Budget'
        });
        return true
      }
      return false
    },
    setDateFromPicker(fieldName, value) {
      this.client.deals[fieldName] = utils.func.formatCustomDate(value, 'DD/MM/YYYY')
      this.client.deals = utils.func.refreshJSON(this.client.deals)
    },
    checkDate(fieldName) {
      // check date format if entered only
      if (!this.client.deals[fieldName]) return
      this.validActivationDate = false
      if (utils.func.isDateFormatValid(this.client.deals[fieldName]) || !this.client.deals[fieldName]) {
        this.validActivationDate = true
      }
      this.client.deals = utils.func.refreshJSON(this.client.deals)
    },
    async checkAccEmail(index) {
      this.invalidContactEmail = false
      this.client.contacts[index].invalid = false
      let contactOne = this.client.contacts[index]
      let resp = await userAPIs.checkClientUser({
        clientID: this.client.id,
        email: contactOne.email.toLowerCase()
      })
      if (!resp.success) {
        // if email exists, show invalid
        this.client.contacts[index].invalid = true
        this.invalidContactEmail = true
      }
    },
    async updateClientUserCampaigns() {
      for (let contact of this.client.contacts) {
        let email = contact.email
        let campaigns = []
        this.client.contacts.map(c => {
          if (c.email === email) {
            if (c.campaigns) {
              c.campaigns.map(campaign => {
                campaigns.push(campaign)
              })
            }
          }
        })
        let updateContact = Object.assign({}, contact)
        updateContact.campaigns = campaigns
        await userAPIs.updateClientUserCampaigns(updateContact)
      }
    },
    showLinkedIO(IOs) {
      if (!Array.isArray(IOs)) return ''
      IOs = IOs.map(i => {
        if (i) {
          if (!i.includes('IO-')) {
            i = `IO-${i}`
          }
        }
        return i
      })
      return IOs.join(', ')
    },
    addLinkIO() {
      this.client.deals.linkedIOs.push('')
    },
    deleteLinkIO(idx) {
      this.client.deals.linkedIOs.splice(idx, 1)
      this.changeLinkedIO()
    }
  },
  async mounted() {
    // Update company select options
    if (this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW) {
      companyAPIs
        .getAllCompanies(false)
        .then(response => {
          this.company_options = response.data;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    }
    // Update sale person select options
    userAPIs
      .getAllUsersByRole(config.userRoles.COMPANY_ADMIN_LOW)
      .then(response => {
        this.salePerson_options = response.users;
      })
      .catch(error => {
        console.log('error', error);
      });
    // Fetch xero contacts
    this.fetchXeroContact();
    this.$store.dispatch('campaign/getCampaignVerticals')
    await this.$store.dispatch('client/getDealNatures')
    this.dealNatureLists = Object.assign([], this.dealNatures);
    // this.getIONumbers()
  }
};
</script>



// WEBPACK FOOTER //
// EditClientModal.vue?7062ea9d